module.exports = __webpack_public_path__ + "static/media/4.f2149d20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4.jpg
// module id = 503
// module chunks = 0